import { KnmPublishStatusesEnum } from '../../../APIPackage/KnmModule/enums/KnmPublishStatusesEnum';
import { IPublishedStatusSelectOption } from '../interfaces/IPublishedStatusSelectOption';

export const erknmPublishedStatusesCodesNamesMap = {
  [KnmPublishStatusesEnum.UNPUBLISHED]: 'Не опубликовано',
  [KnmPublishStatusesEnum.PUBLISHED]: 'Опубликовано',
};

export const erknmPublishedStatusesSelectOptions: IPublishedStatusSelectOption[] = [
  {
    id: 1,
    label: erknmPublishedStatusesCodesNamesMap[KnmPublishStatusesEnum.UNPUBLISHED],
    value: KnmPublishStatusesEnum.UNPUBLISHED,
  },
  {
    id: 2,
    label: erknmPublishedStatusesCodesNamesMap[KnmPublishStatusesEnum.PUBLISHED],
    value: KnmPublishStatusesEnum.PUBLISHED,
  },
];
